.container {
  margin: var(--space-l);
  text-align: center;
}
